import { render } from "./PortfolioWrapper.vue?vue&type=template&id=a00782e8"
import script from "./PortfolioWrapper.vue?vue&type=script&lang=js"
export * from "./PortfolioWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/PortfolioWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a00782e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a00782e8', __exports__)) {
    api.reload('a00782e8', __exports__)
  }
  
  module.hot.accept("./PortfolioWrapper.vue?vue&type=template&id=a00782e8", () => {
    api.rerender('a00782e8', render)
  })

}


export default __exports__